<p>new-document-dlg-process-tran-inter works!</p>
